import React from 'react';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button, Container, Row, Col, Form, FormGroup, Label, Input
} from 'reactstrap';

const CheckInModal = ({
    isOpen,
    toggle,
    selectedEvent,
    checkInState,
    notes,
    setNotes,
    confirmCheckIn,
}) => {
    // Responsive icon sizing
    const iconSize = window.innerWidth < 576 ? '2rem' : '3rem';

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
            <ModalHeader toggle={toggle}>
                Confirm Check-In for {selectedEvent?.title}
            </ModalHeader>
            <ModalBody>
                <Container className="text-center mt-4">
                    <Row className="d-flex justify-content-center text-center">
                        <Col>
                            <Row className="d-flex justify-content-center text-center">
                                {checkInState.map((status) => (
                                    <Col xs="6" sm="6" md="6" className="mb-3" key={status.id}>
                                        <Button
                                            outline
                                            color={status.color_code}
                                            style={{
                                                width: '100%',
                                                height: window.innerWidth < 576 ? '90px' : '120px',
                                            }}
                                            onClick={() => confirmCheckIn(status)}
                                        >
                                            <i className={status.icon} style={{ fontSize: iconSize }}></i>
                                            <div>{status.title}</div>
                                        </Button>
                                    </Col>
                                ))}
                            </Row>
                            <Row className="d-flex justify-content-center text-center">
                                <Col>
                                    <Button 
                                        color="danger" 
                                        style={{ width: '100%' }} 
                                        onClick={() => confirmCheckIn('noshow')}>
                                            No Show
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col md="6" className="mt-3 mt-md-0">
                            <Form>
                                <FormGroup>
                                    <Label for="notes" className="fw-semibold">
                                        Notes
                                    </Label>
                                    <Input
                                        type="textarea"
                                        name="notes"
                                        id="notes"
                                        value={notes}
                                        rows={4}
                                        placeholder="Add any notes"
                                        onChange={(e) => setNotes(e.target.value)}
                                    />
                                </FormGroup>
                            </Form>
                        </Col>
                    </Row>
                </Container>
            </ModalBody>
            <ModalFooter>
                <Button outline className="w-100" onClick={() => confirmCheckIn(null)}>
                    Clear Check-In
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default CheckInModal;
